import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SiteLanguage, WebsiteContext } from '@/app/services/website-context';
import { LanguageService } from 'sham-components/services';
import { mediaUrl } from '@/app/utils/media-url';

@Component({
  selector: 'app-categories-page',
  imports: [RouterLink],
  templateUrl: './categories-page.html',
  styleUrl: './categories-page.css',
})
export class CategoriesPage {
  categories = signal<{ image: string; link: string; title: string }[]>([]);
  readonly mediaUrl = mediaUrl;
  context = inject(WebsiteContext);
  languageService = inject(LanguageService);

  getCurrentLanguage(): SiteLanguage {
    return this.languageService.currentLang() === 'ar' ? 'ar' : 'en';
  }
  async ngOnInit() {
    var res = await this.context.loadCategoriesTree(this.getCurrentLanguage());
    this.categories.set(
      res
        .filter((x) => !x.parentId)
        .map((x) => ({ image: x.photoUrl!, title: x.name, link: x.slug })),
    );
  }
}
